import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { isPresentNode } from '../../utils/isPresentNode';
import { getTestIds } from '../../utils/TestIds';
import { Card } from '../Card';
import { ConditionalWrapper } from '../ConditionalWrapper';
import { Divider } from '../Divider';
import { FullRow } from '../Layout';
import { Typography } from '../Typography';
import styles from './RecordCard.module.scss';
import { typographyPropsOf } from './RecordCard.utils';
const DEFAULT_DIVIDER_MARGIN = 4;
export const GetRecordCardTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const RecordCard = (param)=>{
    let { rows, actions, skin, padding = 's', verticalPadding, borderRadius = 'm', borderSkin = 'default', className, testId } = param;
    const { RecordCardTestIds } = useMemo(()=>GetRecordCardTID(testId), [
        testId
    ]);
    const idFor = (id)=>isPresentNode(testId) ? id : undefined;
    return /*#__PURE__*/ _jsx(Card, {
        // eslint-disable-next-line custom/no-hardcoded-nobi-in-seagull -- WHY: non-actionable Card; rendered as a div with no onClick, so it never emits BI (Card only logs when as==='button').
        noBi: true,
        autoHeight: true,
        padding: padding === 'none' ? undefined : padding,
        verticalPadding: verticalPadding,
        skin: skin,
        borderRadius: borderRadius,
        borderSkin: borderSkin === 'none' ? undefined : borderSkin,
        testId: testId,
        className: cn(styles.card, className),
        children: /*#__PURE__*/ _jsx("div", {
            children: rows.map((row, index)=>{
                var _row_id, _row_dividerMargin, _row_key;
                var _row_label, _row_label1, _row_label2, _row_label3;
                const rowId = (_row_id = row.id) !== null && _row_id !== void 0 ? _row_id : index;
                return /*#__PURE__*/ _jsxs(React.Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ConditionalWrapper, {
                            condition: index === 0 && isPresentNode(actions),
                            wrapper: (children)=>/*#__PURE__*/ _jsxs(FullRow, {
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: styles.rowBeforeActions,
                                            children: children
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: styles.actions,
                                            "data-testid": idFor(RecordCardTestIds.Actions()),
                                            children: actions
                                        })
                                    ]
                                }),
                            children: /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    row.dividerAbove && /*#__PURE__*/ _jsx("div", {
                                        "data-testid": idFor(RecordCardTestIds.Divider(rowId)),
                                        children: /*#__PURE__*/ _jsx(Divider, {
                                            margin: (_row_dividerMargin = row.dividerMargin) !== null && _row_dividerMargin !== void 0 ? _row_dividerMargin : DEFAULT_DIVIDER_MARGIN,
                                            skin: row.dividerSkin
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: cn(styles.row, {
                                            [styles.spread]: row.spread,
                                            [styles.stacked]: row.stacked
                                        }, row.className),
                                        "data-testid": idFor(RecordCardTestIds.Row(rowId)),
                                        children: [
                                            isPresentNode((_row_label = row.label) === null || _row_label === void 0 ? void 0 : _row_label.text) && /*#__PURE__*/ _jsxs(Typography, _object_spread_props(_object_spread({}, typographyPropsOf(row.label)), {
                                                className: cn(styles.label, {
                                                    [styles.shrinkable]: (_row_label1 = row.label) === null || _row_label1 === void 0 ? void 0 : _row_label1.shrinkable
                                                }),
                                                testId: idFor(RecordCardTestIds.Label(rowId)),
                                                children: [
                                                    (_row_label2 = row.label) === null || _row_label2 === void 0 ? void 0 : _row_label2.text,
                                                    !((_row_label3 = row.label) === null || _row_label3 === void 0 ? void 0 : _row_label3.hideColon) && ':'
                                                ]
                                            })),
                                            /*#__PURE__*/ _jsx(Typography, _object_spread_props(_object_spread({}, typographyPropsOf(row.valueTypography)), {
                                                className: cn(styles.value, {
                                                    [styles.withInline]: isPresentNode(row.inline)
                                                }),
                                                testId: idFor(RecordCardTestIds.Value(rowId)),
                                                children: row.value
                                            })),
                                            row.inline
                                        ]
                                    })
                                ]
                            })
                        }),
                        isPresentNode(row.secondary) && /*#__PURE__*/ _jsx("div", {
                            className: styles.row,
                            "data-testid": idFor(RecordCardTestIds.Secondary(rowId)),
                            children: /*#__PURE__*/ _jsx(Typography, {
                                skin: "secondary",
                                className: styles.value,
                                children: row.secondary
                            })
                        })
                    ]
                }, (_row_key = row.key) !== null && _row_key !== void 0 ? _row_key : rowId);
            })
        })
    });
};
